import React from 'react'
import {
  ContainerPricingModel,
  Product,
} from '../../../../modules/productsListing/types'
import { FormikProps, useFormikContext } from 'formik'
import {
  EntitlementOption,
  FieldMetadata,
  FieldMetadataField,
  PrivateOffer,
} from '../../../../modules/privateOffer/types'
import {
  BoxV4,
  NoteV2,
  RadioButtonGroupMapping,
  RadioButtonsV2,
  RadioButtonType,
} from '@labrav/react-components'
import { Typography } from '@mui/material'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShelves } from '@fortawesome/pro-regular-svg-icons'
import { useStyles } from './PrivateOfferAmiDimensions.styles'
import { useSelector } from '../../../../store'
import { StandardDimensionsV2 } from '../../../../common/components/StandardDimensionsV2/StandardDimensionsV2'

export type PrivateOfferAmiDimensionsProps = {
  product: Product
}
export const PrivateOfferAmiDimensions: React.FC<
  PrivateOfferAmiDimensionsProps
> = ({ product }) => {
  const { values, setFieldValue } =
    useFormikContext() as FormikProps<PrivateOffer>
  const formikProps = useFormikContext() as FormikProps<PrivateOffer>
  const { classes } = useStyles()
  const dimensionSelectionMapping: RadioButtonGroupMapping[] = [
    {
      key: EntitlementOption.MANY,
      label: 'Multiple dimensions',
      type: RadioButtonType.STANDARD,
      description:
        'Buyer can choose only one unit of one of the existing dimensions',
    },
    {
      key: EntitlementOption.SINGLE,
      label: 'Single dimensions',
      type: RadioButtonType.STANDARD,
      description: 'Buyer can choose one or more existing dimensions',
    },
  ]
  const handleSelection = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value as string
    setFieldValue('entitlementOption', value)
  }
  const fieldMetadata = useSelector<FieldMetadata | undefined>(
    state =>
      state.privateOffersInCreation.currentPrivateOfferInCreation[
        product.productId
      ]?.fieldMetadata
  )

  const isEntitlementOptionReadOnly = (
    fieldMetadata?.entitlementOption as FieldMetadataField
  )?.readOnly
  const isEntitlementOptionHidden = (
    fieldMetadata?.entitlementOption as FieldMetadataField
  )?.hidden
  return (
    <div data-testid="productDimensions-section">
      <BoxV4
        heading={'Dimensions'}
        headingIcon={
          <FontAwesomeIcon
            icon={faShelves}
            style={{ width: '18px', height: '14px' }}
          />
        }
      >
        {!values.flexiblePaymentTerms &&
          product.containerPricingModel === ContainerPricingModel.CONTRACT &&
          !isEntitlementOptionHidden && (
            <div
              className={classes.sectionContainer}
              data-testid="entitlement-options"
            >
              <Typography className={classes.sectionHeading}>
                Choose the entitlement type you want to offer
              </Typography>
              <RadioButtonsV2
                checkedValue={{
                  key: values?.entitlementOption as string,
                  value: values?.entitlementOption as string,
                }}
                name="entitlementOption"
                radioButtonMappings={dimensionSelectionMapping.map(option => ({
                  ...option,
                  disabled: isEntitlementOptionReadOnly,
                }))}
                border
                vertical={false}
                alignSameHeight
                handleChange={handleSelection}
              />
            </div>
          )}
        <NoteV2
          description={
            <div>
              <span className={classes.noteTitle}>Note:</span> You cannot create
              your private offer without adding atleast one dimension.
            </div>
          }
        />
        <div className={classes.sectionContainer}>
          <div className={classes.textContainer}>
            <Typography className={classes.sectionHeading}>
              Product dimensions
            </Typography>
          </div>
          <StandardDimensionsV2
            product={product}
            formik={
              formikProps as unknown as FormikProps<Record<string, unknown>>
            }
            addButtonName={'Add dimensions'}
            productId={product?.productId}
            isFlexible={values?.flexiblePaymentTerms}
            hideNote
          />
        </div>
      </BoxV4>
    </div>
  )
}
